import React, { useEffect, useRef, useState } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import { Button } from 'primereact/button';
import { saveAs } from 'file-saver';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { LabelField } from './InitialBalance.styles';
import { InputNumber } from 'primereact/inputnumber';
import { FileUpload } from 'primereact/fileupload';
import { Calendar } from 'primereact/calendar';
import useParamsHeadCount from '../../helpers/useParamsHeadCount';
import dateFormat from '../../services/DateFormat.service';
import '../../DataTableDemo.css';
import { ProgressSpinner } from 'primereact/progressspinner';
import "../../utils/tooltip.css"
import Video from '../Video/Video';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import useWindowDimensions from '../hooks/useDimensions';
import './InitialBalance.css'
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { excelReport } from '../../services/excelReport.service';

const InitialBalance = () => {
    // declarar constantes
    const [empleado, setEmpleado] = useState("")

    const [diasEps, setDiasEps] = useState("")
    const [ibcEps, setIbcEps] = useState("")
    const [diasArl, setDiasArl] = useState("")
    const [ibcArl, setIbcArl] = useState("")

    const [diasCesantias, setDiasCesantias] = useState("")
    const [valorCesantias, setValorCesantias] = useState("")
    const [diasInteresCesantias, setDiasInteresCesantias] = useState("")
    const [valorInteresCesantias, setValorInteresCesantias] = useState("")
    const [diasVacaciones, setDiasVacaciones] = useState("")
    const [valorVacaciones, setValorVacaciones] = useState("")
    const [diasPrima, setDiasPrima] = useState("")
    const [valorPrima, setValorPrima] = useState("")

    const [listaEmpleados, setListaEmpleados] = useState([])

    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false)
    const [loading3, setLoading3] = useState(false)
    const [loading4, setLoading4] = useState(false)
    const [loading5, setLoading5] = useState(false)
    const [consultado, setConsultado] = useState(false);
    const [consultado2, setConsultado2] = useState(false);
    const [isOpen, setIsOpen] = React.useState(false);
    const [isOpenA, setIsOpenA] = React.useState(false);
    const [isOpenS, setIsOpenS] = React.useState(false);
    const [isOpen_, setIsOpen_] = React.useState(false);
    const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);
    const [isOpenE, setIsOpenE] = React.useState(false);
    const elementWidth = { width: "20rem", justifySelf: "center" }
    const [loadPage, setLoadPage] = useState(false)

    const headers = { authorization: localStorage.getItem('token') }
    const [products, setProducts] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(5);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const toast = useRef(null);
    const fileUploadRef = useRef(null);
    const { width } = useWindowDimensions()

    // funcion para obtener los empleados
    useEffect(() => {
        // await apis.getBusiness(headers).then(res => {
        //   localStorage.setItem('client', res.data.COMPANY[0]["CLIENT"]);
        // })
        const getLists = async () => {
            await apis.getInitialBalanceList(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
                let data = res.data;
                let empleados = data["CONTRACTS"]
                setListaEmpleados(empleados)
                console.log(data)
                setLoadPage(true)
            })
        }
        getLists()
    }, []);

    useEffect(() => {
        setTabla()
    }, [])

    const showModal = () => {
        setIsOpen(true);
    };

    const hideModal = () => {
        limpiar()
        setIsOpen(false);
    };

    const showModal_ = () => {
        setIsOpen_(true);
    };

    const hideModal_ = () => {
        limpiar()
        setIsOpen_(false);
    };

    const showModalA = () => {
        setIsOpenA(true);
    };

    const hideModalA = () => {
        setIsOpenA(false);
        //limpiar();
    };

    const showModalS = () => {
        setIsOpenS(true);
    };

    const hideModalS = () => {
        setIsOpenS(false);
        //limpiar();
    };

    const showModalEliminar = () => {
        setIsOpenEliminar(true);
    };

    const hideModalEliminar = () => {
        limpiar()
        setIsOpenEliminar(false);
    };

    const footer = (
        <div>
            <Button label="Cancelar" onClick={() => { setLoading(false); hideModal() }} />
            <Button label="Guardar" loading={loading} onClick={() => { setLoading(true); postInitBalance() }} />
        </div>
    );

    const header = (
        <div>
            <h3>Crear saldo inicial</h3>
        </div>
    )

    const footer_ = (
        <div>
            <Button label="Cancelar" onClick={() => { setLoading2(false); limpiar(); hideModal_() }} />
            <Button label="Guardar" loading={loading2} onClick={() => { setLoading2(true); putInitBalance() }} />
        </div>
    );

    const header_ = (
        <div>
            <h3>Editar saldo inicial</h3>
        </div>
    )

    const footerEliminar = (
        <div>
            <Button label="Cancelar" onClick={() => { setLoading3(false); limpiar(); hideModalEliminar() }} />
            <Button label="Eliminar" loading={loading3} onClick={() => { setLoading3(true); deleteInitBalance() }} />
        </div>
    );

    const headerEliminar = (
        <div>
            <h3>Eliminar saldo inicial</h3>
        </div>
    )

    //Evento para cambiar de pagina
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }
    //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
                    <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    };

    //Boton Agregar Persona izquierda de la tabla
    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm "
                    tooltipOptions={{ position: 'top' }} onClick={() => showModal()}
                />
                <Button type="button" icon="pi pi-upload" label="Cargar acumulados" className="p-button-success mr-2 p-button-sm" onClick={() => showModalA()} />
                <Button type="button" icon="pi pi-upload" label="Cargar saldos" className="p-button mr-2 p-button-sm" onClick={() => showModalS()} />
            </React.Fragment>
        )
    }

    //Boton liquidar Nómina en la parte derecha de la tabla
    // const rightToolbarTemplate = () => {
    //     return (
    //         <React.Fragment>
    //             <Button label="Liquidar Nómina" icon="pi pi-building" className="p-button mr-2 p-button-sm " onClick={() => liquidar()} />
    //             <Button label="Head count" icon="pi pi-book" className="p-button mr-2 p-button-sm " tooltip='Generar reporte head count'
    //                 tooltipOptions={{ position: 'top' }} onClick={showModalHC} />
    //         </React.Fragment>
    //     )
    // }

    //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
    const actionBodyTemplate = (rowData) => {
        return (
            <div className='flex flex-row'>
                <Button icon="pi pi-pencil" className="p-button-warning mr-2 p-button-sm text-xs" onClick={() => { initializeData(rowData); showModal_() }} />
                <Button icon="pi pi-trash" className="p-button-danger mr-2 p-button-sm text-xs" onClick={() => { setEmpleado(rowData.CONTRACT); showModalEliminar() }} />
            </div>
        )
    }

    //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm"
                        style={{
                            width: "100%"
                        }}
                    />
                </IconField>
            </div>
        )
    }

    const showConfirm = () => {
        /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
        toast.current.show({
            severity: 'info', sticky: true, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i >
                            <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100	)" animationDuration=".5s" />
                        </i>
                        <p>Cargando información...</p>
                    </div>
                </div>
            )
        });
    }

    //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    //Limpiar e inicializar los filtros
    const clearFilter1 = () => {
        initFilters1();
    }

    //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
    const header1 = renderHeader1();

    //Limpiar filtros de la tabla
    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'JOB_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CONTRACT_TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'RETIREMENT_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    //Nombre de las opciciones para los filtros
    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    async function setTabla() {
        await apis.getInitialBalance(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
            let data = res.data.INIT_BALANCE
            setProducts(data)
        })
    }

    async function postInitBalance() {
        const _client = localStorage.getItem("client")
        const _entity = localStorage.getItem("entity")
        const _empleado = empleado.CODE
        const _diasEps = diasEps
        const _ibcEps = ibcEps
        const _diasArl = diasArl
        const _ibcArl = ibcArl
        const _diasCesantias = diasCesantias
        const _valorCesantias = valorCesantias
        const _diasInteresCesantias = diasInteresCesantias
        const _valorInteresCesantias = valorInteresCesantias
        const _diasVacaciones = diasVacaciones
        const _valorVacaciones = valorVacaciones
        const _diasPrima = diasPrima
        const _valorPrima = valorPrima

        const payload = {
            CLIENT: _client,
            ENTITY: _entity,
            CONTRACT: _empleado,
            EPS_DAY: _diasEps,
            EPS_IBC: _ibcEps,
            ARL_DAY: _diasArl,
            ARL_IBC: _ibcArl,
            CESA_DAY: _diasCesantias,
            CESA_CSO: _valorCesantias,
            CESA_INT_DAY: _diasInteresCesantias,
            CESA_INT_CSO: _valorInteresCesantias,
            VAC_DAY: _diasVacaciones,
            VAC_CSO: _valorVacaciones,
            PRIM_DAY: _diasPrima,
            PRIM_CSO: _valorPrima
        }

        try {
            await apis.postInitialBalance(payload, headers).then(res => {
                setLoading(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Saldo inicial agregado exitosamente' });
            })
            setTabla()
            hideModal()
            limpiar()
        }
        catch (err) {
            setLoading(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function putInitBalance() {
        const _client = localStorage.getItem("client")
        const _entity = localStorage.getItem("entity")
        const _empleado = empleado
        const _diasEps = diasEps
        const _ibcEps = ibcEps
        const _diasArl = diasArl
        const _ibcArl = ibcArl
        const _diasCesantias = diasCesantias
        const _valorCesantias = valorCesantias
        const _diasInteresCesantias = diasInteresCesantias
        const _valorInteresCesantias = valorInteresCesantias
        const _diasVacaciones = diasVacaciones
        const _valorVacaciones = valorVacaciones
        const _diasPrima = diasPrima
        const _valorPrima = valorPrima

        const payload = {
            CLIENT: _client,
            ENTITY: _entity,
            CONTRACT: _empleado,
            EPS_DAY: _diasEps,
            EPS_IBC: _ibcEps,
            ARL_DAY: _diasArl,
            ARL_IBC: _ibcArl,
            CESA_DAY: _diasCesantias,
            CESA_CSO: _valorCesantias,
            CESA_INT_DAY: _diasInteresCesantias,
            CESA_INT_CSO: _valorInteresCesantias,
            VAC_DAY: _diasVacaciones,
            VAC_CSO: _valorVacaciones,
            PRIM_DAY: _diasPrima,
            PRIM_CSO: _valorPrima
        }

        try {
            await apis.putInitialBalance(payload, headers).then(res => {
                setLoading2(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Saldo inicial actualizado exitosamente' });
            })
            setTabla()
            hideModal_()
            limpiar()
        }
        catch (err) {
            setLoading2(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function deleteInitBalance() {
        const _cliente = localStorage.getItem("client")
        const _entity = localStorage.getItem("entity")
        const _empleado = empleado

        try {
            await apis.deleteInitialBalance(_entity, _cliente, _empleado, headers).then(res => {
                setLoading3(false)
                toast.current.show({ severity: 'info', summary: 'Info', detail: 'Saldo inicial eliminado exitosamente' });
            })
            setTabla()
            limpiar()
            hideModalEliminar()
        }
        catch (err) {
            setLoading3(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function downloadSampleFile() {
        let payload = {
            NAME: "UploadAccumulated",
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity'),
            OPTION: 2
        }
        let sampleFile = []
        try {
            await apis.uploadHistoricPayroll(payload, headers).then(res => {
                sampleFile = res.data
                //console.log(sampleFile)
                excelReport(sampleFile, 'PlantillaCargueAcumulados')
                setLoading4(false)
            });
        }
        catch (err) {
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: err.response.data.message, sticky: true });
            setLoading4(false)
        }
    }

    async function downloadSampleFileSS() {
        let payload = {
            NAME: "UploadAccumulated",
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity'),
            OPTION: 2
        }
        let sampleFile = []
        try {
            await apis.uploadSocialSecurity(payload, headers).then(res => {
                sampleFile = res.data
                //console.log(sampleFile)
                excelReport(sampleFile, 'PlantillaCargueSeguridadSocial')
                setLoading5(false)
            });
        }
        catch (err) {
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: err.response.data.message, sticky: true });
            setLoading5(false)
        }
    }

    async function loadError(lines) {
        /*Función encargada de gnerar el archivo txt de errores del cargue*/
        const blob = new Blob([lines], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
        saveAs(blob, "ErroresCargue.txt");
    }

    async function importData(_importedData) {
        /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
        try {
            await apis.uploadHistoricPayroll(_importedData, headers).then(res => {
                setConsultado(false)
                toast.current.clear()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
            })
        }
        catch (err) {
            loadError(err.response.data.message)
            setConsultado(false)
            toast.current.clear()
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
        }
    }

    async function importDataSS(_importedData) {
        /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
        try {
            await apis.uploadSocialSecurity(_importedData, headers).then(res => {
                setConsultado2(false)
                toast.current.clear()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
            })
        }
        catch (err) {
            loadError(err.response.data.message)
            setConsultado2(false)
            toast.current.clear()
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
        }
    }

    async function importHistoricPayroll(e) {
        /*Función encargada de formatear los datos del archivo Excel para subirlos*/
        setConsultado(true);
        showConfirm();
        const file = e.files[0];

        import('xlsx').then(xlsx => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });

                // Prepare DataTable
                data.shift();

                let _importedData = {
                    NAME: "UploadAccumulated",
                    CLIENT: localStorage.getItem('client'),
                    ENTITY: localStorage.getItem('entity'),
                    OPTION: 1,
                    DETAIL: []
                }

                let lines = 1
                data.forEach(row => {
                    let _line = ""
                    row.forEach(element => {
                        _line += element + "|"
                    })
                    _line = _line.slice(0, -1)
                    _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
                    lines++
                })

                importData(_importedData)
            };
            reader.readAsArrayBuffer(file);
        });
    }

    async function importSocialSecurity(e) {
        /*Función encargada de formatear los datos del archivo Excel para subirlos*/
        setConsultado2(true);
        showConfirm();
        const file = e.files[0];

        import('xlsx').then(xlsx => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });

                // Prepare DataTable
                data.shift();

                let _importedData = {
                    NAME: "UploadSocialSecurity",
                    CLIENT: localStorage.getItem('client'),
                    ENTITY: localStorage.getItem('entity'),
                    OPTION: 1,
                    DETAIL: []
                }

                let lines = 1
                data.forEach(row => {
                    let _line = ""
                    row.forEach(element => {
                        _line += element + "|"
                    })
                    _line = _line.slice(0, -1)
                    _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
                    lines++
                })

                importDataSS(_importedData)
            };
            reader.readAsArrayBuffer(file);
        });
    }

    async function initializeData(rowData) {
        setEmpleado(rowData.CONTRACT)
        setDiasEps(rowData.EPS_DAY)
        setIbcEps(rowData.EPS_IBC)
        setDiasArl(rowData.ARL_DAY)
        setIbcArl(rowData.ARL_IBC)
        setDiasCesantias(rowData.CESA_DAY)
        setValorCesantias(rowData.CESA_CSO)
        setDiasInteresCesantias(rowData.CESA_INT_DAY)
        setValorInteresCesantias(rowData.CESA_INT_CSO)
        setDiasVacaciones(rowData.VAC_DAY)
        setValorVacaciones(rowData.VAC_CSO)
        setDiasPrima(rowData.PRIM_DAY)
        setValorPrima(rowData.PRIM_CSO)
    }

    async function limpiar() {
        setEmpleado("")
        setDiasEps("")
        setIbcEps("")
        setDiasArl("")
        setIbcArl("")
        setDiasCesantias("")
        setValorCesantias("")
        setDiasInteresCesantias("")
        setValorInteresCesantias("")
        setDiasVacaciones("")
        setValorVacaciones("")
        setDiasPrima("")
        setValorPrima("")
    }

    const formatCurrency = (value) => {
        let currency = parseInt(value)
        return currency.toLocaleString('es-CO', { style: 'currency', currency: 'COP' });
    }

    const ibcEpsBodyTemplate = (rowData) => {
        if (rowData.EPS_IBC) {
            return formatCurrency(parseInt(rowData.EPS_IBC));
        } else {
            return "";
        }
    }

    const ibcArlBodyTemplate = (rowData) => {
        if (rowData.ARL_IBC) {
            return formatCurrency(parseInt(rowData.ARL_IBC));
        } else {
            return "";
        }
    }

    const valorCesantiasBodyTemplate = (rowData) => {
        if (rowData.CESA_CSO) {
            return formatCurrency(parseInt(rowData.CESA_CSO));
        } else {
            return "";
        }
    }

    const valorInteresCesantiasBodyTemplate = (rowData) => {
        if (rowData.CESA_INT_CSO) {
            return formatCurrency(parseInt(rowData.CESA_INT_CSO));
        } else {
            return "";
        }
    }

    const valorVacacionesBodyTemplate = (rowData) => {
        if (rowData.VAC_CSO) {
            return formatCurrency(parseInt(rowData.VAC_CSO));
        } else {
            return "";
        }
    }

    const valorPrimaBodyTemplate = (rowData) => {
        if (rowData.PRIM_CSO) {
            return formatCurrency(parseInt(rowData.PRIM_CSO));
        } else {
            return "";
        }
    }

    const footerA = (
        <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
            <Button style={{ marginLeft: "-6rem" }} onClick={() => { setLoading4(false); setLoading5(false); hideModalA() }}>Cancelar</Button>
            <Button type="button" icon="pi pi-file-excel" label="Plantilla" loading={loading4} onClick={() => { setLoading4(true); downloadSampleFile() }} />
            <FileUpload ref={fileUploadRef} disabled={consultado} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importHistoricPayroll}>
            </FileUpload>
        </div>
    );

    const headerA = (
        <div>
            <h3>Cargar acumulados</h3>
        </div>
    )

    const footerSS = (
        <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
            <Button style={{ marginLeft: "-6rem" }} onClick={() => { setLoading5(false); hideModalS() }}>Cancelar</Button>
            <Button type="button" icon="pi pi-file-excel" label="Plantilla" loading={loading5} onClick={() => { setLoading5(true); downloadSampleFileSS() }} />
            <FileUpload ref={fileUploadRef} disabled={consultado2} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importSocialSecurity}>
            </FileUpload>
        </div>
    );

    const headerSS = (
        <div>
            <h3>Cargar saldos</h3>
        </div>
    )


    // Return que entrega la pantalla
    return (
        <div className='mt-2'>
            <Dialog header={header} footer={footer} visible={isOpen}
                position="top" style={{ width: "30rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                <div>
                    <LabelField htmlFor="label">Contrato</LabelField>
                    <Dropdown style={{ width: "18rem" }} value={empleado} autoFocus
                        filter showClear filterBy="NAME" emptyMessage={"No hay contratos disponibles"}
                        options={listaEmpleados} placeholder={"Seleccione el empleado"}
                        onChange={(e) => {
                            setEmpleado(e.value)
                        }}
                        optionLabel='NAME' className='mb-2'
                    />
                </div>
                <span className="text-xl font-bold">Seguridad social</span>
                <div className='flex flex-row'>
                    <div>
                        <LabelField htmlFor="label2">Días EPS</LabelField>
                        <InputText
                            style={{ width: "6rem" }}
                            id="label2"
                            type="number"
                            min={0}
                            value={diasEps}
                            onChange={(e) => setDiasEps(e.target.value)} />
                    </div>
                    <div className='ml-1'>
                        <LabelField htmlFor="label">IBC EPS</LabelField>
                        <InputNumber value={ibcEps}
                            onValueChange={(e) => { setIbcEps(e.value) }}
                            mode="currency" currency="COP" locale="es-CO" />
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div>
                        <LabelField htmlFor="label">Dias ARL</LabelField>
                        <InputText
                            style={{ width: "6rem" }}
                            id="label2"
                            type="number"
                            min={0}
                            value={diasArl}
                            onChange={(e) => setDiasArl(e.target.value)} />
                    </div>
                    <div className='ml-1'>
                        <LabelField htmlFor="label">IBC ARL</LabelField>
                        <InputNumber value={ibcArl}
                            onValueChange={(e) => { setIbcArl(e.value) }}
                            mode="currency" currency="COP" locale="es-CO" />
                    </div>
                </div>
                <span className="text-xl font-bold">Consolidado de prestaciones sociales</span>
                <div className='flex flex-row'>
                    <div>
                        <LabelField htmlFor="label">Días cesantías</LabelField>
                        <InputText
                            style={{ width: "6rem" }}
                            id="label2"
                            type="number"
                            min={0}
                            value={diasCesantias}
                            onChange={(e) => setDiasCesantias(e.target.value)} />
                    </div>
                    <div className='-ml-1'>
                        <LabelField htmlFor="label">Valor cesantías</LabelField>
                        <InputNumber value={valorCesantias}
                            onValueChange={(e) => { setValorCesantias(e.value) }}
                            mode="currency" currency="COP" locale="es-CO" />
                    </div>
                </div>
                <div className='flex flex-row justify-content-end'>
                    <div className='-mt-2'>
                        <LabelField htmlFor="label">Días interéses de cesantías</LabelField>
                        <InputText
                            style={{ width: "6rem" }}
                            id="label2"
                            type="number"
                            min={0}
                            value={diasInteresCesantias}
                            onChange={(e) => setDiasInteresCesantias(e.target.value)} />
                    </div>
                    <div className='mt-3 -ml-5'>
                        <LabelField htmlFor="label">Valor interéses de cesantías</LabelField>
                        <InputNumber value={valorInteresCesantias}
                            onValueChange={(e) => { setValorInteresCesantias(e.value) }}
                            mode="currency" currency="COP" locale="es-CO" />
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div>
                        <LabelField htmlFor="label">Días vacaciones</LabelField>
                        <InputText
                            style={{ width: "6rem" }}
                            id="label2"
                            type="number"
                            min={0}
                            value={diasVacaciones}
                            onChange={(e) => setDiasVacaciones(e.target.value)} />
                    </div>
                    <div className='-ml-2'>
                        <LabelField htmlFor="label">Valor vacaciones</LabelField>
                        <InputNumber value={valorVacaciones}
                            onValueChange={(e) => { setValorVacaciones(e.value) }}
                            mode="currency" currency="COP" locale="es-CO" />
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div>
                        <LabelField htmlFor="label">Días prima</LabelField>
                        <InputText
                            style={{ width: "6rem" }}
                            id="label2"
                            type="number"
                            min={0}
                            value={diasPrima}
                            onChange={(e) => setDiasPrima(e.target.value)} />
                    </div>
                    <div className='ml-2'>
                        <LabelField htmlFor="label">Valor prima</LabelField>
                        <InputNumber value={valorPrima}
                            onValueChange={(e) => { setValorPrima(e.value) }}
                            mode="currency" currency="COP" locale="es-CO" />
                    </div>
                </div>
            </Dialog>
            <Dialog header={header_} footer={footer_} visible={isOpen_}
                position="top" style={{ width: "30rem" }} draggable={false} resizable={false} modal onHide={hideModal_}>
                <span className="text-xl font-bold">Seguridad social</span>
                <div className='flex flex-row'>
                    <div>
                        <LabelField htmlFor="label2">Días EPS</LabelField>
                        <InputText
                            style={{ width: "6rem" }}
                            id="label2"
                            type="number"
                            min={0}
                            value={diasEps}
                            onChange={(e) => setDiasEps(e.target.value)} />
                    </div>
                    <div className='ml-1'>
                        <LabelField htmlFor="label">IBC EPS</LabelField>
                        <InputNumber value={ibcEps}
                            onValueChange={(e) => { setIbcEps(e.value) }}
                            mode="currency" currency="COP" locale="es-CO" />
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div>
                        <LabelField htmlFor="label">Dias ARL</LabelField>
                        <InputText
                            style={{ width: "6rem" }}
                            id="label2"
                            type="number"
                            min={0}
                            value={diasArl}
                            onChange={(e) => setDiasArl(e.target.value)} />
                    </div>
                    <div className='ml-1'>
                        <LabelField htmlFor="label">IBC ARL</LabelField>
                        <InputNumber value={ibcArl}
                            onValueChange={(e) => { setIbcArl(e.value) }}
                            mode="currency" currency="COP" locale="es-CO" />
                    </div>
                </div>
                <span className="text-xl font-bold">Consolidado de prestaciones sociales</span>
                <div className='flex flex-row'>
                    <div>
                        <LabelField htmlFor="label">Días cesantías</LabelField>
                        <InputText
                            style={{ width: "6rem" }}
                            id="label2"
                            type="number"
                            min={0}
                            value={diasCesantias}
                            onChange={(e) => setDiasCesantias(e.target.value)} />
                    </div>
                    <div className='-ml-1'>
                        <LabelField htmlFor="label">Valor cesantías</LabelField>
                        <InputNumber value={valorCesantias}
                            onValueChange={(e) => { setValorCesantias(e.value) }}
                            mode="currency" currency="COP" locale="es-CO" />
                    </div>
                </div>
                <div className='flex flex-row justify-content-end'>
                    <div className='-mt-2'>
                        <LabelField htmlFor="label">Días interéses de cesantías</LabelField>
                        <InputText
                            style={{ width: "6rem" }}
                            id="label2"
                            type="number"
                            min={0}
                            value={diasInteresCesantias}
                            onChange={(e) => setDiasInteresCesantias(e.target.value)} />
                    </div>
                    <div className='mt-3 -ml-5'>
                        <LabelField htmlFor="label">Valor interéses de cesantías</LabelField>
                        <InputNumber value={valorInteresCesantias}
                            onValueChange={(e) => { setValorInteresCesantias(e.value) }}
                            mode="currency" currency="COP" locale="es-CO" />
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div>
                        <LabelField htmlFor="label">Días vacaciones</LabelField>
                        <InputText
                            style={{ width: "6rem" }}
                            id="label2"
                            type="number"
                            min={0}
                            value={diasVacaciones}
                            onChange={(e) => setDiasVacaciones(e.target.value)} />
                    </div>
                    <div className='-ml-2'>
                        <LabelField htmlFor="label">Valor vacaciones</LabelField>
                        <InputNumber value={valorVacaciones}
                            onValueChange={(e) => { setValorVacaciones(e.value) }}
                            mode="currency" currency="COP" locale="es-CO" />
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div>
                        <LabelField htmlFor="label">Días prima</LabelField>
                        <InputText
                            style={{ width: "6rem" }}
                            id="label2"
                            type="number"
                            min={0}
                            value={diasPrima}
                            onChange={(e) => setDiasPrima(e.target.value)} />
                    </div>
                    <div className='ml-2'>
                        <LabelField htmlFor="label">Valor prima</LabelField>
                        <InputNumber value={valorPrima}
                            onValueChange={(e) => { setValorPrima(e.value) }}
                            mode="currency" currency="COP" locale="es-CO" />
                    </div>
                </div>
            </Dialog>
            <Dialog header={headerEliminar} footer={footerEliminar} visible={isOpenEliminar}
                position="top" style={{ width: "30rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
            </Dialog>
            <Dialog header={headerA} footer={footerA} visible={isOpenA}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalA}>
                <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
                <br />
                <span>2. Diligencie la hoja Modelo de Cargue, teniendo en cuenta los códigos de concepto presentados en la hoja Conceptos del cliente.</span>
                <br />
                <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
            </Dialog>
            <Dialog header={headerSS} footer={footerSS} visible={isOpenS}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalS}>
                <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
                <br />
                <span>2. Diligencie la hoja UploadContract_ini_abalance, teniendo en cuenta los contratos presentados en la hoja Contratos.</span>
                <br />
                <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
            </Dialog>
            <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
                <Toast ref={toast} />

                <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
                    <span className="text-900">Saldos iniciales</span>
                    <Video header="Instructivo saldos iniciales" url={localStorage.getItem('INITIALBALANCE_VIDEO')} />
                </div>


                <div className="card mt-4">
                    <SkeletonTable load={loadPage}>
                        <Toolbar start={leftToolbarTemplate}></Toolbar>
                        <DataTable className="text-xs" value={products} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                            dataKey="CONTRACT" selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)}
                            size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['CONTRACT_ID', 'NUMBER_ID', 'NAME', 'JOB_ID', 'CONTRACT_TYPE', 'STATUS', 'START_DATE', 'END_DATE', 'RETIREMENT_DATE']}
                            header={header1} >
                            <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                            <Column field="CONTRACT" header="Contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} sortable></Column>
                            <Column field="NUMBER_ID" header="Identificación" showFilterOperator={false} filterMatchModeOptions={matchModes} sortable></Column>
                            <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} sortable></Column>
                            <Column field="EPS_DAY" header="Días EPS" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
                            <Column field="EPS_IBC" header="IBC EPS" body={ibcEpsBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
                            <Column field="ARL_DAY" header="Días ARL" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
                            <Column field="ARL_IBC" header="IBC ARL" body={ibcArlBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Cargo" sortable></Column>
                            <Column field="CESA_DAY" header="Días cesantías" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tipo de contrato" sortable></Column>
                            <Column field="CESA_CSO" header="Valor cesantías" body={valorCesantiasBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
                            <Column field="CESA_INT_DAY" header="Días interéses de cesantías" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha ingreso" sortable></Column>
                            <Column field="CESA_INT_CSO" header="Valor interéses de cesantías" body={valorInteresCesantiasBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha fin contrato" sortable></Column>
                            <Column field="VAC_DAY" header="Días vacaciones" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha retiro" sortable></Column>
                            <Column field="VAC_CSO" header="Valor vacaciones" body={valorVacacionesBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha retiro" sortable></Column>
                            <Column field="PRIM_DAY" header="Días prima" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha retiro" sortable></Column>
                            <Column field="PRIM_CSO" header="Valor prima" body={valorPrimaBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha retiro" sortable></Column>
                            <Column headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible', width: "6rem" }} body={actionBodyTemplate} />
                        </DataTable>
                    </SkeletonTable>
                </div>

            </div>

        </div >
    );
}

export default InitialBalance